export default __webpack_public_path__ + "static/media/img-nailsalon.d87c2598.png";